<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" icon="el-icon-plus" style="margin: 8px 0;" @click="add">添加</el-button>
        <el-table :data="tableData" style="width: 100%" border :show-header="false">
          <el-table-column width="60" align="center" type="index" />
          <el-table-column width="90">
            <template slot-scope="{row,$index}" v-if="$index>0">
              <el-select v-model="row.LeftPart" clearable placeholder="" @change="change(row)" style="width:100%;">
                <!-- <el-option value="" /> -->
                <el-option value="("/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" align="center">
            <template slot-scope="{row,$index}">
              <span v-if="$index==0">基础信息</span>
              <el-select v-else v-model="row.c1" @change="c1Change(row)" style="width:100%;">
                <el-option v-for="item in mainList" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="{row,$index}">
              <el-select v-model="row.vs" multiple clearable @change="change(row)" style="width:100%;">
                <el-option v-for="item in getList(row.c1,$index)" :key="item.pn" :label="item.name" :value="item.pn" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="90">
            <template slot-scope="{row,$index}" v-if="$index>0">
              <el-select v-model="row.RightPart" clearable placeholder="" @change="change(row)" style="width:100%;">
                <!-- <el-option value="" /> -->
                <el-option value=")"/>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="90">
            <template slot-scope="{row,$index}" v-if="$index>0">
              <el-select v-model="row.ConditionOperator" placeholder="" @change="change(row)" style="width:100%;">
                <el-option value="或" />
                <el-option value="和" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column align="center" width="70px">
            <template slot-scope="{row,$index}" v-if="$index>0">
              <el-button type="text" icon="el-icon-delete" @click="del(row,$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
const mainList = [
  // { name: "基础信息", value: "BaseInfo" },
  { name: "主题班会", value: "Theme" },
  { name: "个人德育类荣誉", value: "EduHoner" },
  { name: "个人德育类奖项", value: "EduAward" },
  { name: "所带班级表彰获奖", value: "ClassAward" },
  { name: "公开课", value: "OpenClass" },
  { name: "教学1类竞赛获奖", value: "Edu1Race" },
  { name: "教学2类竞赛获奖", value: "Edu2Race" },
  { name: "教学类荣誉", value: "TeachHoner" },
  { name: "论文发表", value: "Paper" },
  { name: "教育科研项目", value: "EduProject" },
  { name: "著作出版", value: "Book" },
  { name: "教育教学科研成果", value: "EduResult" },
  { name: "参加学术团体", value: "Group" },
  { name: "指导教师", value: "GuideTeacher" },
  { name: "专题讲座", value: "Lecture" },
  { name: "综合性荣誉称号", value: "ComHoner" },
  { name: "指导学生", value: "GuideStudent" },
  { name: "学习培训", value: "Train" },
];
export default {
  components: {
      
  },
  data() {
    return {
      data: {
        QueryPlanId: 0,
        QueryPlanName: "",
        TeacherId: 0,
        TeacherNumber: "",
        TeacherName: "",
        QueryPlanType: 1,
        Groups: [],
      },
      mainList,
      BaseInfo: [
        { name: "现任年级", pn: "NowGradeIds" },
        { name: "科目", pn: "Subjects" },
        { name: "姓名", pn: "TeacherName" },
        { name: "性别", pn: "Sex" },
        { name: "入职年份", pn: "InYear" },
        { name: "最高学历", pn: "Edu" },
        { name: "政治面貌", pn: "Politics" },
        { name: "兼任职务", pn: "JobNames" },
        { name: "职称", pn: "Titles" },
        { name: "是否完成支教", pn: "HasSupport" },
        { name: "任现职称年限", pn: "EvaluateYear" },
        { name: "德育总年限", pn: "JobYear" },
        { name: "任现职德育总年限", pn: "NowJobYear" },
        { name: "任现职是否完成大循环", pn: "GradeCycle" },
        { name: "任现职是否任高三3年以上", pn: "Grade3More" },
      ],
      Theme: [
        { name: "承担时间", pn: "BearDate" },
        { name: "级别", pn: "GdLvs" },
      ],
      EduHoner: [
        { name: "荣誉名称", pn: "EduHonerName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "级别", pn: "GdLvs" },
      ],
      EduAward: [
        { name: "奖项名称", pn: "EduAwardName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "级别", pn: "GdLvs" },
        { name: "等次", pn: "GdGrades" },
      ],
      ClassAward: [
        { name: "表彰名称", pn: "ClassAwardName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "级别", pn: "GdLvs" },
        { name: "等次", pn: "GdGrades" },
      ],
      OpenClass: [
        { name: "承担时间", pn: "BearDate" },
        { name: "级别", pn: "GdLvs" },
      ],
      Edu1Race: [
        { name: "奖项名称", pn: "Edu1RaceName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "类型", pn: "GdTypes" },
        { name: "级别", pn: "GdLvs" },
        { name: "等次", pn: "GdGrades" },
      ],
      Edu2Race: [
        { name: "奖项名称", pn: "Edu2RaceName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "类型", pn: "GdTypes" },
        { name: "级别", pn: "GdLvs" },
        { name: "等次", pn: "GdGrades" },
      ],
      TeachHoner: [
        { name: "所属项目", pn: "TeachHonerName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "级别", pn: "GdLvs" },
      ],
      Paper: [
        { name: "发表时间", pn: "PublishDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
        { name: "本人角色", pn: "Roles" },
      ],
      EduProject: [
        { name: "立项时间", pn: "ProjectDate" },
        { name: "结题时间", pn: "FinishDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
        { name: "本人角色", pn: "Roles" },
      ],
      Book: [
        { name: "出版时间", pn: "PublishDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "本人撰写部分", pn: "WriteParts" },
      ],
      EduResult: [
        { name: "奖项名称", pn: "EduResultName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
        { name: "等次", pn: "GdGrades" },
      ],
      Group: [
        { name: "团体名称", pn: "GroupName" },
        { name: "获得时间", pn: "JoinDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
        { name: "本人角色", pn: "Roles" },
      ],
      GuideTeacher: [
        { name: "项目名称", pn: "GuideTeacherName" },
        { name: "项目时间", pn: "ProjectDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
      ],
      Lecture: [
        { name: "承担时间", pn: "BearDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
      ],
      ComHoner: [
        { name: "荣誉名称", pn: "ComHonerName" },
        { name: "获得时间", pn: "GetDate" },
        { name: "级别", pn: "GdLvs" },
      ],
      GuideStudent: [
        { name: "项目名称", pn: "GuideStudentName" },
        { name: "项目时间", pn: "ProjectDate" },
        { name: "类别", pn: "GdCategorys" },
        { name: "级别", pn: "GdLvs" },
      ],
      Train: [
        // { name: "项目名称", pn: "TrainName" },
        { name: "活动主题", pn: "Theme" },
        { name: "项目时间", pn: "ProjectDate" },
        { name: "类型", pn: "GdTypes" },
        { name: "级别", pn: "GdLvs" },
      ],
      tableData: [],
      delList: [],
    };
  },
  methods: {
    begin(data) {
      this.tableData = [];
      this.delList = [];
      if(data) {
        data.Groups.forEach(e => {
          // e.T = 1;
          delete e.T;
          e.vs = [];
          e.dl = [];
          e.Dts.forEach((n,index) => {
            if(index==0) {
              e.c1 = n.ApiParamName.split("_")[0];
            }
            e.vs.push(n.ApiParamName.split("_")[1]);
            e.dl.push({ ...n, T:2 })
          })
        })
        this.data = data;
        this.tableData = data.Groups;
      } else {
        this.data = {
          QueryPlanId: 0,
          QueryPlanName: "",
          TeacherId: 0,
          TeacherNumber: "",
          TeacherName: "",
          QueryPlanType: 1,
          Groups: [],
        };
        this.tableData.push({
          T: 0,
          Dts: [],
          dl: [],
          c1: "BaseInfo",
          vs: [],
          QueryGroupId: 0,
          QueryPlanId: 0,
          LeftPart: "",
          ClassName: "基础信息",
          RightPart: "",
          ConditionOperator: "",
          Sn: 0,
        })
      }
    },
    add() {
      this.tableData.push({
        T: 0,
        Dts: [],
        dl: [],
        c1: "Theme",
        vs: [],
        QueryGroupId: 0,
        QueryPlanId: this.data.QueryPlanId,
        LeftPart: "",
        ClassName: "",
        RightPart: "",
        ConditionOperator: "或",
        // Sn: 0,
      })
    },
    c1Change(row) {
      row.vs = [];
      if(!(row.T===0)) row.T = 1;
    },
    change(row) {
      if(!(row.T===0)) row.T = 1;
    },
    toSave() {
      var td = this.tableData;
      var to = [];
      for (let i = 0; i < td.length; i++) {
        const e = td[i];
        if(!e.vs || e.vs.length == 0) {
          this.$message.error("第" + (i+1) + "行信息不完整");
          return;
        }
        if(e.T === 0 || e.T === 1) {
          if(i > 0) {
            var find2 = this.mainList.find(x => x.value == e.c1);
            if(find2) e.ClassName = find2.name;
          }
          var dts = [];
          for (let j = 0; j < e.vs.length; j++) {
            const m = e.vs[j];
            var DtsName = "";
            var ApiParamName = "";
            var find = this[e.c1].find(x => x.pn == m);
            if(find) {
              DtsName = find.name;
              ApiParamName = e.c1 + "_" + find.pn;
            }
            var obj = {
              T: 0,
              QueryGroupDtsId: 0,
              QueryGroupId: e.QueryGroupId,
              QueryPlanId: this.data.QueryPlanId,
              DtsName,
              ApiParamName,
              ApiParamValue: ""
            };
            var obj2 = e.dl.find(x => x.ApiParamName == obj.ApiParamName);
            if(!obj2) {
              dts.push(obj);
            }
          }
          e.Dts = dts;
          e.dl.forEach(k => {
            if(e.vs.indexOf(k.ApiParamName.split("_")[1]) == -1) {
              e.Dts.push(k);
            }
            // var obj3 = e.Dts.find(x => e.vs.indexOf(k.ApiParamName.split("_")[1]) == -1 );
            // if(!obj3) {
            //   e.Dts.push(k);
            // }
          })
          // e.Dts = dts.concat(e.dl);
          to.push(e);
        }
      }
      // console.log("?!",to);
      // return;
      this.data.Groups = to.concat(this.delList);
      this.data.Groups.forEach((e,index) => {
        e.Sn = index;
      })
      return this.data;
    },
    del(row,index) {
      if(!(row.T===0)) {
        this.delList.push({ ...row, T: 2 });
      }
      this.tableData.splice(index,1);
    },
    getList(v,index) {
      return index==0?this.BaseInfo:this[v];
    },
  },
};
</script>